import { COLOR } from '@bugbug/core/theme/colors';
import styled from 'styled-components';

import Page from '~/components/Page';
import { TableBody } from '~/components/Table';

export const ListContainer = styled(Page)`
  ${TableBody} {
    overflow-y: hidden;
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
  position: relative;
`;

export const SortAndFilters = styled.div`
  margin: 0 auto 0 18px;
`;

export const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: 30px;
`;

export const LoaderContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: ${COLOR.WHITE};

  > * {
    position: relative;
    bottom: calc(50vh - 32px);
  }
`;

export const TableEmptyState = styled.div`
  background-color: ${COLOR.WHITE};
  position: relative;
  height: 100%;

  ${LoaderContainer} {
    top: 25px;
  }
`;

export const NameCellContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
`;

export const EmptyBadgeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.status.warning};
  border-radius: 4px;
  padding: 2px 4px;
  flex-shrink: 0;
  margin: 0 12px;
`;

export const EmptyBadgeLabel = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1;
  font-weight: bold;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.common.white};
  margin-bottom: 1px;
`;
